import util from './util'
import api from './api'
import $http from './http'
import { Message } from "element-ui"

const install = {}
install.install = function (Vue) {
    Vue.prototype.$api = api;
    Vue.prototype.$http = $http;
    Vue.prototype.global = util;

    Vue.prototype.$fileType = {
        sheet: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',//xlsx
        excel: 'application/vnd.ms-excel',
        pdf: '.pdf,.PDF',
        ofd: '.ofd,.OFD',
        img: '.jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.PBG,.BMP',
    }

    Vue.prototype.$msg = {
        warn: message => Message({ type: 'warning', message: message || '' }),
        success: message => Message({ type: 'success', message: message || '成功' })
    }

    Vue.prototype.$utils = {
        downloadFile: util.downloadFile,
        downloadBlob: util.downloadBlob
    }

}
export default install